<template>
  <div class="list-table">
    <v-container fluid grid-list-xl>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field
                clearable
                flat
                hide-details
                placeholder="Busqueda..."
                solo
                v-model="search"
              ></v-text-field>
              <v-btn icon>
                <v-icon @click="onSearch">search</v-icon>
              </v-btn>
              <v-btn @click="onDownload" icon color="success">
                <v-icon>cloud_download</v-icon>
              </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :items="users"
                :loading="pagination.loading"
                :total-items="pagination.totalItems"
                hide-actions
                no-data-text="Datos no disponibles"
                no-results-text="No se encontraron registros coincidentes"
              >
                <template slot="items" slot-scope="props">
                  <td class="text-sm-left">{{ props.item.firstName }}</td>
                  <td class="text-sm-left">{{ props.item.lastName }}</td>
                  <td class="text-sm-left">{{ props.item.email }}</td>
                  <td class="text-sm-left">
                    {{ props.item.role ? props.item.role.name : '---' }}
                  </td>
                  <td class="text-sm-left">
                    <v-btn
                      :to="`/usuarios/editar/${props.item.id}`"
                      color="info"
                      flat
                      icon
                    >
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn
                      @click="
                        userDisable.modal = true
                        userDisable.id = props.item.id
                      "
                      color="error"
                      flat
                      icon
                    >
                      <v-icon>remove_circle</v-icon>
                    </v-btn>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <div class="text-xs-center pt-2" v-if="pagination.pages">
            <v-pagination
              :length="pagination.pages"
              :total-visible="7"
              @input="asyncPagination"
              v-model="pagination.page"
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog max-width="350" persistent v-model="loading">
      <loading></loading>
    </v-dialog>
    <v-dialog max-width="400" v-model="userDisable.modal">
      <v-card>
        <v-card-title class="headline">Desactivar Usuario</v-card-title>

        <v-card-text>
          <p>
            Estas a punto de desactivar a un usuario permanentemente, este
            proceso no puede ser revertido.
          </p>
          <p>Estas Seguro?</p>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="userDisable.modal = false" color="primary" text
            >Cancelar</v-btn
          >
          <v-btn @click="disableUser" color="error" text>OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import loading from './../dialog/DialogLoading'

export default {
  components: {
    loading,
  },
  data() {
    return {
      search: '',
      loading: true,
      userDisable: {
        modal: false,
        id: null,
      },
      pagination: {
        page: 1,
        rpp: this.$config.resultsPerPage,
        totalItems: 0,
        loading: true,
        pages: 0,
        search: {},
      },
      complex: {
        headers: [
          {
            text: 'Nombre',
            value: 'firstName',
            align: 'left',
            sortable: false,
          },
          {
            text: 'Apellido',
            value: 'lastName',
            align: 'left',
            sortable: false,
          },
          {
            text: 'Email',
            value: 'email',
            align: 'left',
            sortable: false,
          },
          {
            text: 'Rol',
            value: 'role.name',
            align: 'left',
            sortable: false,
          },
          {
            text: 'Acciones',
            align: 'left',
            sortable: false,
          },
        ],
      },
    }
  },
  created() {
    this.asyncPagination()
  },
  methods: {
    helperPaginate(response) {
      this.pagination.totalItems = response.total
      this.pagination.pages =
        Math.ceil(this.pagination.totalItems / this.pagination.rpp) || 0
      this.loading = false
      this.pagination.loading = false
    },
    asyncPagination() {
      this.pagination.loading = true

      let filter = {
        rpp: this.pagination.rpp,
        page: this.pagination.page,
        ...this.pagination.search,
      }

      return new Promise(resolve => {
        this.$store.dispatch('users/getAll', filter).then(response => {
          this.helperPaginate(response)
          return resolve()
        })
      })
    },
    onSearch() {
      const params = { term: this.search }

      Object.keys(params).forEach(function(key) {
        if (params[key] == null || params[key] == '') delete params[key]
      })

      this.pagination.search = params
      this.pagination.page = 1
      this.asyncPagination()
    },
    onDownload() {
      const filter = {
        ...this.pagination.search,
      }
      this.$socket.emit('exportUsers', filter)
    },
    disableUser() {
      this.userDisable.modal = false
      this.loading = true

      this.$store
        .dispatch('users/disable', { id: this.userDisable.id })
        .then(response => {
          if (response.data == 0) {
            this.loading = false
            this.dialog = {
              message:
                'El usuario no pudo ser desactivado, contacte al soporte tecnico',
              show: true,
              color: 'red',
              key: this.dialog.key + 1,
            }
          } else {
            this.asyncPagination()
          }
        })
    },
  },
  computed: {
    ...mapState({
      users: state => state.users.all,
    }),
  },
}
</script>
